import React from 'react';
import { NextPage } from 'next';
import { SpacingLayout } from 'components/atoms';
import { PrivacyPolicy } from 'templates/company';
import { SEO } from 'templates/layout';

const Privacy: NextPage = () => {
  return (
    <SpacingLayout>
      <SEO title={'Privacy policy'} />
      <PrivacyPolicy />
    </SpacingLayout>
  );
};

export default Privacy;
